// prettier-ignore
export const FILE_NOT_PDF = "FILE_NOT_PDF" as const
export const FILE_NOT_FOUND = "FILE_NOT_FOUND" as const
export const GENERIC_ERROR = "GENERIC_ERROR" as const
export const BROWSER_ERROR = "BROWSER_ERROR" as const
export const PERMISSION_ERROR = "PERMISSION_ERROR" as const